/* eslint-disable prettier/prettier */
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { orderStatusArray, subOrderStatusArray } from 'src/constants';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Typography } from '@mui/material';

export default function HorizontalStepper({ status, isSubOrder }) {
  const [activeStep, setActiveStep] = useState();
  const [failed, setFailed] = useState(false);
  const activeSubOrderStatus = (status) => {
    switch (status[status.length - 1].status) {
      case 'IN_PROGRESS':
        setActiveStep(1);
        break;
      case 'PREPARING':
        setActiveStep(2);
        break;
      case 'READY_FOR_DISPATCHED':
        setActiveStep(3);
        break;
      case 'DISPATCHED':
        setActiveStep(4);
        break;
      case 'DELIVERED':
        setActiveStep(5);
        break;
      default:
        setActiveStep(null);
        break;
    }
  };
  const activeMainOrderStatus = (status) => {
    switch (status[status.length - 1].status) {
      case 'PENDING_REVIEW':
        setActiveStep(1);
        break;
      case 'NEGOTIATION_SUCCESSFUL':
        setActiveStep(2);
        break;
      case 'NEGOTIATION_FAILURE':
        setFailed(true);
        setActiveStep(1);
        break;
      case 'PAYMENT_RECEIVED':
        setActiveStep(3);
        break;
      case 'COMPLETED':
        setActiveStep(4);
        break;
      default:
        setActiveStep(null);
        break;
    }
  };
  const transformedStatus = (
    isSubOrder
      ? subOrderStatusArray.filter((_, index) => index !== 0 && index !== 1)
      : orderStatusArray.filter((_, index) => index !== 0 && (failed ? index !== 2 : index !== 3))
  ).map(({ label }) => {
    const logEntry = status?.find((log) => log.status === label);
    return {
      label: label,
      time: logEntry ? logEntry.updatedAt : null,
    };
  });
  useEffect(() => {
    isSubOrder ? activeSubOrderStatus(status) : activeMainOrderStatus(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {transformedStatus.map((step, index) => (
          <Step
            sx={{
              '& .MuiStepIcon-root': {
                fontSize: {
                  sm: '2rem',
                  xs: '1.5rem',
                },
                color: activeStep === index && (failed ? 'red' : 'gray'),
              },
              '& .MuiStepLabel-label': {
                fontSize: '0.9rem',
                marginTop: '8px',
                color: !isSubOrder && '#fff',
              },
              '& .MuiSvgIcon-root': {
                fill: !isSubOrder && activeStep > index && 'white',
              },
              '& .MuiStepConnector-root': {
                display: !isSubOrder && 'none',
              },
            }}
            key={index}
          >
            <StepLabel icon={failed && activeStep === index ? 'X' : index + 1}>{t(`labels.${step.label}`)}</StepLabel>
            {step.time && (
              <Typography
                sx={{
                  textAlign: 'center',
                  fontSize: { sm: '0.9rem', xs: '0.7rem' },
                  color: isSubOrder ? 'inherit' : 'white',
                }}
              >
                {new Date(step.time).toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true,
                })}
              </Typography>
            )}
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
